import { NumberField } from '@base-ui/react/number-field';
import { Box, TextField } from '@mui/material';
import React from 'react';

import { tryParseInt } from '../../../lib/numbers';
import { InputProps, InputRenderer } from '../types';

export const MAX_POSTAL_DIGITS = 9999;
export const MIN_POSTAL_DIGITS = 1000;

interface PostalDigitsInputProps extends InputProps {
  index?: number;
  rangeIndex: number;
}

const PostalDigitsInput = ({ index, name, onBlur, onChange, rangeIndex, value }: PostalDigitsInputProps) => {
  const splitRange = (value ?? '').split('-');
  const handleChange = (newVal: number | null) => {
    const newRange = splitRange.slice();
    newRange[rangeIndex] = newVal?.toString() ?? '';

    onChange({ target: { value: newRange.join('-') } });
  };
  const nameWithIndex = `${name}-${index}-${rangeIndex}`;

  return (
    <NumberField.Root
      required
      format={{ useGrouping: false }}
      max={MAX_POSTAL_DIGITS}
      min={MIN_POSTAL_DIGITS}
      name={nameWithIndex}
      value={tryParseInt(splitRange[rangeIndex]) ?? null}
      onBlur={onBlur}
      onValueChange={handleChange}
    >
      <NumberField.Input
        render={(props) => <TextField {...props} color={undefined} name={`${nameWithIndex}-ui`} size="small" />}
      />
    </NumberField.Root>
  );
};

const PostalRangeInput = (props: InputRenderer) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    }}
  >
    <PostalDigitsInput index={props.index} rangeIndex={0} {...props.inputProps} />
    -
    <PostalDigitsInput index={props.index} rangeIndex={1} {...props.inputProps} />
  </Box>
);

export default PostalRangeInput;
